<template>
  <v-dialog
    v-model="dialog"
    max-width="30rem"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        v-if="helper"
        block
        @click="getIsAdmin ? adminLogout() : (dialog = true)"
        color="success"
        dark
      >
        <v-icon small left>fa-user-shield</v-icon>
        Administrateur
      </v-btn>
      <v-btn
        v-else
        text
        icon
        @click="getIsAdmin ? adminLogout() : (dialog = true)"
        :color="getIsAdmin ? 'success' : ''"
      >
        <v-icon>fa-user-shield</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="pa-1">
        <v-row dense no-gutters align="start" justify="end">
          <v-btn small icon text @click="dialog = !dialog">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row v-if="errors.length > 0">
          <v-col cols="12">
            <v-alert type="error" text :value="errors.length > 0">
              <span v-for="(error, index) in errors" :key="index">{{
                error
              }}</span>
            </v-alert>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              ref="adminInput"
              v-model="password"
              label="Mot de passe administrateur"
              prepend-icon="fa-user-shield"
              required
              hide-details="auto"
              autocomplete="off"
              name="adminpassword"
              :append-icon="showPass ? 'fa-eye' : 'fa-eye-slash'"
              @click:append="() => (showPass = !showPass)"
              :type="showPass ? 'text' : 'adminpassword'"
              :rules="[v => !!v || 'Un mot de passe est requis']"
              :disabled="loading"
              dense
              filled
              class="no-before"
            ></v-text-field>
          </v-col>
          <v-col cols="12" v-show="loading">
            <v-progress-linear indeterminate></v-progress-linear>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-row align="center" justify="end" no-gutters>
          <v-btn
            small
            color="success"
            @click="adminLogin"
            :disabled="!password || loading"
            :block="$vuetify.breakpoint.xsOnly"
            :large="$vuetify.breakpoint.smAndDown"
          >
            <v-icon left small>fa-check</v-icon>Soumettre
          </v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "UserAdminLogin",
  props: {
    helper: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["getIsAdmin"])
  },
  data() {
    return {
      dialog: false,
      errors: [],
      password: "",
      valid: null,
      loading: false,
      showPass: false,
      enterListener: null
    };
  },
  methods: {
    async adminLogin() {
      this.showPass = false;
      if (this.password && this.password !== null && this.password !== "") {
        this.errors = [];
        try {
          this.loading = true;
          await this.$store.dispatch("startLoadingOverlay");
          await this.$store.dispatch("adminLogin", this.password);
          this.dialog = false;
        } catch (error) {
          this.errors = [];
          for (var key in error.data) {
            error.data[key].forEach(errorMessage => {
              this.errors.push(`${key}: ${errorMessage}`);
            });
          }
        } finally {
          this.loading = false;
          this.$store.dispatch("endLoadingOverlay");
        }
      }
    },
    submitLogin(v) {
      if (v.key === "Enter") {
        this.adminLogin();
      }
    },
    async adminLogout() {
      this.$store.dispatch("adminLogout");
    }
  },
  watch: {
    dialog(v) {
      if (v === false) {
        setTimeout(() => (this.password = ""), 1000);
        this.errors = [];
        document.removeEventListener("keydown", v => this.submitLogin(v));
      } else {
        setTimeout(() => this.$refs.adminInput.focus(), 100);
        document.addEventListener("keydown", v => this.submitLogin(v));
      }
    }
  }
};
</script>

<style></style>
